import { Link } from 'react-router-dom'
import PageTransition from '@/components/ui/PageTransition'

export default function NotFoundPage() {
  return (
    <PageTransition>
      <section className="flex flex-col justify-center max-w-container mx-auto px-6 sm:px-8 pt-6 md:pt-10 min-h-[60vh]">
        <div className="flex flex-col gap-6 max-w-text">
          <p className="text-label uppercase tracking-widest text-accent">404</p>
          <h1 className="text-h1 text-text-secondary">This page wandered off.</h1>
          <p className="text-body text-text-muted">
            The link may be outdated or the work you&apos;re looking for has moved. Head back to the
            portfolio to explore the latest motion work.
          </p>
          <div>
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-body text-text-primary border-b border-accent pb-1 hover:opacity-80 transition-opacity"
            >
              Back to work
              <span aria-hidden="true">→</span>
            </Link>
          </div>
        </div>
      </section>
    </PageTransition>
  )
}
